import { TeacherResponseDto } from "../shared/dtos/teacher/TeacherResponseDto";
import { TeacherSummaryDto } from "../shared/dtos/teacher/TeacherSummaryDto";

export class TeacherMapper {
  public static mapTeacherToSummary(
    detailedTeacher: TeacherResponseDto,
  ): TeacherSummaryDto {
    return {
      id: detailedTeacher.id,
      teacherId: detailedTeacher.teacherId,
      name: detailedTeacher.firstName,
      email: detailedTeacher.email,
      primaryPhoneNumber: detailedTeacher.primaryPhoneNumber,
      dateOfJoining: detailedTeacher.dateOfJoining,
      gender: detailedTeacher.gender,
      qualifications: detailedTeacher.qualifications,
      branchName: detailedTeacher.branchName,
    };
  }
}
